import React from 'react';

interface Props {
  customerPortalUrl?: string;
  cancelSubscriptionUrl?: string;
  pendingCancellation?: boolean;
  linkClassName?: string;
  textClassName?: string;
  cancelLinkStyle?: React.CSSProperties;
}

export default function SubscriptionManagementLinks(props: Props) {
  const { 
    customerPortalUrl, 
    cancelSubscriptionUrl, 
    pendingCancellation,
    linkClassName,
    textClassName,
    cancelLinkStyle = { color: '#f51f00' }
  } = props;

  const handleCancelClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (confirm('Are you sure you want to cancel your subscription? It will remain active until the end of your current billing period.')) {
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = cancelSubscriptionUrl!;

      const methodInput = document.createElement('input');
      methodInput.type = 'hidden';
      methodInput.name = '_method';
      methodInput.value = 'PATCH';
      form.appendChild(methodInput);

      const tokenInput = document.createElement('input');
      tokenInput.type = 'hidden';
      tokenInput.name = 'authenticity_token';
      tokenInput.value = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '';
      form.appendChild(tokenInput);

      document.body.appendChild(form);
      form.submit();
    }
  };

  if (pendingCancellation) {
    return (
      <p className={textClassName}>
        Your subscription is scheduled to be cancelled at the end of the current billing period.
      </p>
    );
  }

  return (
    <>
      {customerPortalUrl && (
        <p className={textClassName}>
          Need to update your payment method ?&nbsp;
          <a
            href={customerPortalUrl}
            className={linkClassName}
            rel='noreferrer'
          >
            Manage payment methods
          </a>
          .
        </p>
      )}
      {cancelSubscriptionUrl && (
        <p className={textClassName}>
          Need to cancel your subscription?&nbsp;
          <a
            href={cancelSubscriptionUrl}
            className={linkClassName}
            style={cancelLinkStyle}
            onClick={handleCancelClick}
          >
            Cancel here
          </a>
          . Your subscription will remain active until the end of your current billing period.
        </p>
      )}
    </>
  );
}